<template>
  <div>
    <TheProductSwitcher :rightLink="switcherRight" />
    <TheNavigationHeader>
      <div slot="leftSide">
        <div @click.stop="toggleOrgSelector">
          <MenuHeader
            class="px-2 ml-2 cursor-pointer"
            :class="{
              'opacity-25 cursor-not-allowed': !multiLocation,
              'py-1 rounded hover:bg-iron': multiLocation
            }"
            ref="user-menu-header"
          >
            <div slot="title">{{ locationMenuTitle }}</div>
            <div slot="subtitle">{{ locationMenuSubtitle }}</div>
            <div slot="icon">
              <BaseIcon
                :name="orgSelectorToggle ? 'chevron-up' : 'chevron-down'"
                height="14"
                width="14"
              />
            </div>
          </MenuHeader>
        </div>
        <BaseTransition>
          <Dualist
            v-if="orgSelectorToggle && multiLocation"
            v-click-outside="{
              exclude: ['user-menu-header'],
              handler: closeOrgSelector
            }"
            class="absolute z-50 sm:mt-2"
            :currentLocationId="currentSubsidiaryId"
            :environments="accessibleFranchisors"
            :errorLoadingLocations="errorLoadingSubsidiaries"
            :useRouterLink="true"
            :initialEnvironmentId="currentEnvironmentId"
            :isRep="isRep"
            :isLoadingLocations="isLoadingSubsidiaries"
            @close="closeOrgSelector"
            @locations-retry="onSelectEnvironment"
            @select-environment="onSelectEnvironment"
            @select-location="onSelectLocation"
          />
        </BaseTransition>
      </div>
      <div class="flex items-center flex-row-reverse" slot="rightSide">
        <TheUserMenu
          :user="user"
          @item-clicked="menuClicked"
          @logout="logout"
        />
        <Search @search="onSearch" />
      </div>
    </TheNavigationHeader>
    <TheNavigationTabs
      :useRouterLink="true"
      :leftTabs="leftTabs"
      :rightTabs="rightTabs"
      :includeSupportLink="true"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
  Dualist,
  MenuHeader,
  Search,
  TheNavigationHeader,
  TheNavigationTabs,
  TheProductSwitcher,
  TheUserMenu,
  clickOutside
} from '@listen360/alexandria'
export default {
  name: 'TheNavigation',
  directives: {
    clickOutside
  },
  components: {
    Dualist,
    MenuHeader,
    Search,
    TheNavigationHeader,
    TheNavigationTabs,
    TheProductSwitcher,
    TheUserMenu
  },
  data() {
    return {
      environment: {},
      orgSelectorToggle: false,
      leftTabs: [
        { title: 'Home', path: '/' },
        { title: 'Customers', path: '/customers' },
        { title: 'Prospects', path: '/prospects' },
        { title: 'Reports', path: '/reports' }
      ],
      rightTabs: [{ title: 'Settings', path: '/settings' }],
      switcherRight: { title: 'Reviews', path: '#' },
      isRep: true
    }
  },
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  mounted() {
    this.getAccessibleFranchisors().then(() => {
      if (this.currentEnvironmentId) {
        this.getAccessibleFranchisor({
          environmentId: this.currentEnvironmentId
        })
      }
    })
  },
  computed: {
    ...mapGetters({
      accessibleFranchisors: 'user/accessibleFranchisors',
      currentEnvironment: 'user/currentEnvironment',
      currentSubsidiary: 'user/currentSubsidiary',
      tempEnvironment: 'user/tempEnvironment'
    }),
    currentEnvironmentId() {
      return this.currentEnvironment.id
    },
    currentSubsidiaryId() {
      return this.currentSubsidiary.id
    },
    errorLoadingSubsidiaries() {
      return Boolean(this.tempEnvironment.error)
    },
    isLoadingSubsidiaries() {
      return this.tempEnvironment.isLoading
    },
    locationMenuTitle() {
      return this.currentEnvironment.name || 'Listen360'
    },
    locationMenuSubtitle() {
      return this.currentSubsidiary.name || 'Executive Summary'
    },
    multiEnvironment() {
      return this.accessibleFranchisors.length > 1
    },
    multiLocation() {
      return (
        this.multiEnvironment ||
        (this.accessibleFranchisors[0] &&
          this.accessibleFranchisors[0].subsidiaries &&
          this.accessibleFranchisors[0].subsidiaries.length > 1)
      )
    }
  },
  methods: {
    ...mapActions({
      getAccessibleFranchisor: 'user/getAccessibleFranchisor',
      getAccessibleFranchisors: 'user/getAccessibleFranchisors',
      logout: 'user/logout',
      setCurrentEnvironment: 'user/setCurrentEnvironment',
      setCurrentSubsidiary: 'user/setCurrentSubsidiary',
      setTempEnvironment: 'user/setTempEnvironment'
    }),
    closeOrgSelector() {
      this.orgSelectorToggle = false
      this.resetTempEnvironment()
    },
    menuClicked(link) {
      if (link.path) {
        this.$router.push(link.path)
      }
    },
    onSearch(query) {
      this.$emit('search', query)
    },
    onSelectEnvironment(environment) {
      if (!environment.subsidiaries && !environment.isLoading) {
        this.getAccessibleFranchisor({ environmentId: environment.id })
      }

      this.setTempEnvironment(environment)
    },
    onSelectLocation(subsidiary) {
      this.setCurrentSubsidiary(subsidiary)
      this.setCurrentEnvironment(this.tempEnvironment)

      this.orgSelectorToggle = false
    },
    resetTempEnvironment() {
      this.setTempEnvironment(this.currentEnvironment)
    },
    toggleOrgSelector() {
      if (this.multiLocation) {
        this.orgSelectorToggle = !this.orgSelectorToggle
        this.resetTempEnvironment()
      }
    }
  },
  watch: {
    accessibleFranchisors(curr, prev) {
      if (prev.length === 0 && curr.length === 1) {
        this.setCurrentEnvironment(curr[0])
      }
    }
  }
}
</script>
